define('SuiteDynamics.PickedForYouHomepage.Slider.Collection',
	[
		'underscore',
		'Item.Collection'
	],
	function (
		_,
		ItemCollection
	)
{
	'use strict';

	return ItemCollection.extend({
		initialize: function(options) {
			this.searchApiMasterOptions = { fieldset: 'pickedforyou', include: '' }
			this.itemsIds = _.pluck(options.itemIds, 'internalid');
		},

		fetchItems: function() {
			return this.fetch({ data: { id: this.itemsIds.join(',') } });
		}
	});
});
